import { IResourceComponentsProps } from "@refinedev/core";

import { ChatMessageCreateEdit } from "./components/ChatMessageCreateEdit";

export const ChatMessageCreate: React.FC<IResourceComponentsProps> = () => {
  return <ChatMessageCreateEdit type="create" />;
};
